import { createBrowserHistory } from 'history'
export default createBrowserHistory({
  /* pass a configuration object here if needed */
})